import React, { useEffect } from "react";
import styles from "./CategoryForm.module.css";
import PropTypes from "prop-types";

import { FastField, Field, Form, Formik } from "formik";
import InputFiled from "shared/components/InputField";
import Button from "@material-ui/core/Button";
import * as Yup from "yup";
import { ERROR_MESSAGE } from "shared/Constants";
import { useDispatch, useSelector } from "react-redux";
import { fetchCreateCategoryRequest } from "redux/ActionCreators/CategoryActionCreators";
import { fetchListCategoryParentRequest } from "redux/ActionCreators/CategoryParentActionCreator";
import SelectFiled from "shared/components/SelectField/index";

function CategoryForm(props) {
  const dispatch = useDispatch();

  const categoriesParent = useSelector((state) =>
    state.categoriesParent.list.map((item) => {
      return {
        value: item.id,
        name: item.name,
      };
    })
  );

  useEffect(() => {
    dispatch(fetchListCategoryParentRequest());
  }, []);

  const handleSubmit = (data) => {
    data = { ...data, categoryParent: { id: data.categoryParent } };
    dispatch(fetchCreateCategoryRequest(data));
  };

  return (
    <div>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => {
          return (
            <Form className={styles.content}>
              <div className={styles.item}>
                <FastField
                  name="name"
                  component={InputFiled}
                  label="Tên thể loại"
                />
              </div>

              <div className={styles.item}>
                <Field
                  name="categoryParent"
                  component={SelectFiled}
                  label="Thể Loại Cha"
                  className={styles.item}
                  options={categoriesParent}
                />
              </div>

              <Button
                variant="contained"
                color="secondary"
                size="large"
                type="submit"
                className={styles.btn_submit}
              >
                Lưu Lai
              </Button>
            </Form>
          );
        }}
      </Formik>
    </div>
  );
}

CategoryForm.propTypes = {};

const initialValues = {
  name: "",
  categoryParent: 106,
};

const validationSchema = Yup.object().shape({
  name: Yup.string().required(ERROR_MESSAGE.TEXT_FIELD_REQUIRED),
  categoryParent: Yup.number().required(ERROR_MESSAGE.TEXT_FIELD_REQUIRED),
});

export default CategoryForm;
